import { Component, h, ComponentChild } from 'preact'
import Icon from '../assets'
import ButtonControl from '../button-control'
import ImportBox from './ImportBox'
import { Message } from '../../control-components/ui-components/Message'
import ImportErrors from './ImportErrors'

type Props = {
  infoText: string,
  uploadFile: (file: File) => void,
  showImportSuccess: boolean,
  showImportError: boolean,
  onTryAgain: () => void,
  calloutText: string,
  isLoading: boolean,
  uploadedCount?: number,
  errors?: [],
  type: string,
  successAction?: ComponentChild
}

type State = {
  fileName?: string,
  file: File | null,
  uploadedCompaniesCount?: number | null
}

class ImportView extends Component<Props, State> {
  downloadLink: string

  constructor (props: Props) {
    super(props)
    this.setState({
      fileName: undefined
    })
    this.downloadLink = `/${props.type}/download`
  }

  openFileSelector () {
    const fileUploader: HTMLElement | null = document.querySelector('#file-selector')

    if (fileUploader) {
      fileUploader.click()
    }
  }

  setFileName(event: Event) {
    const target = event.target as HTMLInputElement
    const uploadedFile: File = (target.files as FileList)[0]
    const uploadedFileName: string = uploadedFile.name
    this.setState({
      fileName: uploadedFileName,
      file: uploadedFile
    })
  }

  removeSelectedFile (e: Event) {
    if (this.props.isLoading) {
      return
    }

    const target = e.target as HTMLInputElement
    target.value = ''
    this.setState({
      fileName: undefined,
      file: null
    })
  }

  showImportView () {
    this.setState({
      fileName: undefined,
      file: null
    })
    this.props.onTryAgain()
  }

  render({ infoText, uploadFile, showImportSuccess, showImportError, calloutText, isLoading, type, uploadedCount, errors, successAction }: Props, { fileName, file }: State) {
    return (
      <div className='import-container'>
        {
          showImportSuccess && <div>
            <ImportBox icon='answer' iconClass='icon-import-success' title='Import complete!'>
              <div className='import-statistics'>
                <div className='import-statistics-count'>
                  <div className='upload-number'>{uploadedCount}</div>
                  <div className='upload-description'>{type.charAt(0).toUpperCase() + type.slice(1)} imported</div>
                </div>
                {
                  errors && errors.length !== undefined ? <div className='import-statistics-count'>
                    <div className='upload-number'>{errors.length}</div>
                    <div className='upload-description'>Errors</div>
                  </div> : null
                }
              </div>
              <ButtonControl
                variant='secondary'
                newStyle
                size='medium'
                title={`Go back to ${type} overview`}
                onClick={() => window.location.assign(`/${type}/overview`)}
              />
              { successAction || null }
            </ImportBox>
            { errors && errors.length > 0 ? <ImportErrors errors={errors} /> : null }
          </div>
        }
        {
          showImportError &&
          <ImportBox icon='warning' iconClass='icon-import-error' title='Import failed :('>
            <div className='upload-description'>Please download the <a href={this.downloadLink} className='download-link' target='_blank'>template CSV file</a> and check that your file matches the format of the template.</div>
            <ButtonControl
              variant='brand'
              newStyle
              size='medium'
              title='Try again'
              onClick={() => this.showImportView()}
            />
          </ImportBox>
        }
        {
          !showImportSuccess && !showImportError &&
          <div className='import-data-container'>
            <Message text={calloutText} />
            <div className='upload-container'>
              <Icon customClass='icon-upload' icon='upload'/>
              <div className='upload-title-text'>Upload your CSV file</div>
              <div className='upload-info-text'>{infoText}</div>
              <div className='upload-link'>
                <div>
                  {
                    fileName === undefined ? <div>
                      <ButtonControl
                        variant='brand'
                        newStyle
                        size='medium'
                        class='qa-file-selector'
                        title=' Select file from your computer'
                        onClick={() => this.openFileSelector()}
                      />
                      <input
                        type='file'
                        id='file-selector'
                        style='display:none;'
                        onChange={(e: Event) => this.setFileName(e)}
                        accept='.csv'
                      />
                    </div>
                    : <div className='upload-file-wrapper'>
                      <span className='icon-file-name'>
                        <Icon customClass='icon-file' icon='file'/>
                      </span>
                      <span className='upload-file-name'>{fileName}</span><span> (<a onClick={(e: Event) => this.removeSelectedFile(e)} className={`remove-file ${isLoading ? 'remove-file-disabled' : ''}`}>Remove</a>)</span>
                    </div>
                  }
                  {
                    fileName &&
                    <ButtonControl
                      variant='brand'
                      newStyle
                      size='medium'
                      class='upload-file'
                      title='Upload file'
                      onClick={() => uploadFile(file as File)}
                      isLoading={isLoading}
                    />
                  }
                </div>
              </div>
              {
                !fileName &&
                <div>
                  <div className='download-wrapper'>
                    <a href={this.downloadLink} target='_blank'>
                      <span className='icon-download-link'>
                        <Icon customClass='icon-download' icon='download'/>
                      </span>
                      <span className='download-link'>Download template CSV file</span>
                    </a>
                  </div>
                </div>
              }
           </div>
          </div>
        }
      </div>
    )
  }
}
export default ImportView
